export const viewDcrModalStyles = {
	modal: {
		titleRow: {
			alignItems: 'flex-start'
		}
	},

	profileMetaData: {
		root: { p: 0 },
		nameInfoContainer: { p: 0 }
	},

	table: (width: number) => ({
		width,
		minWidth: '100%'
	}),

	modalHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		gap: 1,
		width: '100%'
	},

	modalBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0,
		width: '100%',
		maxHeight: '50vh'
	},
	dcrMetaData: (minWidth: number) => ({
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		width: '100%',
		boxSizing: 'border-box',
		padding: 2,
		backgroundColor: 'grey.50',
		border: '1px solid #dedede',
		borderRadius: 1,
		minWidth
	}),

	cell: (width: number) => ({ width }),

	row: {
		minHeight: 56,
		'& .MuiTableCell-root': {
			verticalAlign: 'top',
			padding: 1,
			fontSize: 16,
			borderBottom: '1px solid',
			borderColor: 'divider'
		},
		'& .MuiTableCell-root:first-of-type': {
			fontWeight: 700
		}
	},

	resizerContainer: {
		height: 'calc(100% - 2 * var(--mui-spacing))',
		width: '8px',
		position: 'absolute',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		my: 1,
		right: -4,
		top: 0,
		zIndex: 33,
		cursor: 'col-resize',
		'&:hover .resizer': {
			opacity: 1
		}
	},
	resizer: (isResizing: boolean) => ({
		height: '100%',
		width: '1px',
		backgroundColor: 'divider',
		transition: 'opacity 0.2s ease-in-out',
		opacity: 0,
		'&:hover': {
			opacity: 1
		},
		...(isResizing && { opacity: 1, backgroundColor: 'primary.main' })
	}),

	processing: {
		width: '100%',
		height: 200,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	}
};
